import moment from 'moment';

export const shareLinksInitialState = {
  shareLinks: {
    data: [],
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false,
    },
    filters: {
      startDate: moment().utc()
        .startOf('month')
        .hours(1),
      endDate: moment().utc()
        .endOf('month')
        .hours(1),
      filtering: {
        selected: { value: 'earnings', label: 'Earnings' },
        options: [
            { value: 'earnings', label: 'Earnings' },
            { value: 'fans', label: 'Fans' },
        ]
      },
    },
    claimsQty: 0,
    revenue: 0,
    payments: {
      earnings : [], 
      fans: []
    },
    rawPayments: {
      earnings : [], 
      fans: []
    }

  }
};
